export function toggle_header_view(bool) {
    return {
        type: 'CHANGE_HEADER_VIEW',
        bool
    };
}

export function update_filter(text) {
    return {
        type: 'UPDATE_FILTER',
        text
    };
}

export function toggle_navigation_menu(bool) {
    return {
        type: 'TOGGLE_NAVUGATION_MENU',
        bool
    };
}